import React, { useContext } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { SnapshotNavContext } from '../../contexts/SnapshotNavContext';

export const ContestsSubmenu = ({ slug }) => {
  const { contests = [] } = useContext(SnapshotNavContext);
  if (contests.length === 0) {
    return null;
  }

  return (
    <span className="d-none">
      <li className="sidebar-subheader">
        Contests
      </li>
      { contests.map(contest => (
        <li key={contest.slug} className={slug === contest.slug ? 'active' : ''}>
          <Link to={`/snapshots/contests/${contest.slug}`}>{contest.title}</Link>
        </li>
      ))}
    </span>
  );
};

export const PartnersSubmenu = ({ slug }) => {
  const { partners = [] } = useContext(SnapshotNavContext);
  if (partners.length === 0) {
    return null;
  }

  return (
    <span>
      <li className="sidebar-subheader">
        Partners
      </li>
      { partners.map(partner => (
        <li key={partner.slug} className={slug === partner.slug ? 'active' : ''}>
          <Link to={`/snapshots/gallery/${partner.slug}`}>{partner.title}</Link>
        </li>
      ))}
    </span>
  );
};

export const ChannelsSubmenu = ({ slug }) => {
  const { channels = [] } = useContext(SnapshotNavContext);
  if (channels.length === 0) {
    return null;
  }

  return (
    <span>
      <li className="sidebar-subheader">
        Channels
      </li>
      { channels.map(channel => (
        <li key={channel.slug} className={slug === channel.slug ? 'active' : ''}>
          <Link to={`/snapshots/${channel.slug}`}>{channel.title}</Link>
        </li>
      ))}
    </span>
  );
};

const propTypes = {
  slug: PropTypes.string,
};

const defaultProps = {
  slug: '',
};

ContestsSubmenu.propTypes = propTypes;
ContestsSubmenu.defaultProps = defaultProps;
PartnersSubmenu.propTypes = propTypes;
PartnersSubmenu.defaultProps = defaultProps;
ChannelsSubmenu.propTypes = propTypes;
ChannelsSubmenu.defaultProps = defaultProps;
